/*import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}*/
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service.js';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent implements OnInit {
  isLoggedIn: boolean = false;
  /*videoUrl: string = 'https://your-cloudfront-or-s3-url/video.mp4';*/
  videoUrl: string = '/assets/res/Test.mp4';

  constructor(private authService: AuthenticationService) {}

  ngOnInit(): void {
    // Check if the user is logged in
    this.isLoggedIn = !!this.authService.get_user();
  }
}
